'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _equals = require('ramda/src/equals');

var _equals2 = _interopRequireDefault(_equals);

var _pick = require('ramda/src/pick');

var _pick2 = _interopRequireDefault(_pick);

var _toObservable = require('./toObservable');

var _toObservable2 = _interopRequireDefault(_toObservable);

var _most = require('most');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

exports.default = function (effect$) {
  return effect$.filter(function (x) {
    return x;
  }).map((0, _pick2.default)(['fn', 'args', 'onValue', 'onError'])).skipRepeatsWith(_equals2.default).flatMap(function (_ref) {
    var fn = _ref.fn,
        _ref$args = _ref.args,
        args = _ref$args === undefined ? [] : _ref$args,
        _ref$onValue = _ref.onValue,
        onValue = _ref$onValue === undefined ? noop : _ref$onValue,
        _ref$onError = _ref.onError,
        onError = _ref$onError === undefined ? noop : _ref$onError;
    return (0, _toObservable2.default)(fn.apply(null, args)).map(onValue).recoverWith(function (e) {
      return (0, _most.of)(onError(e));
    });
  }).filter(function (x) {
    return x;
  });
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-heat/lib/render.js
// module id = 355
// module chunks = 0